import React from "react";
import data from "../../../data/services.json";
function Services() {
  return (
    <div
      className="sec-box services section-padding bord-thin-bottom"
      id="services"
    >
      <div className="sec-head mb-80 wow fadeInUp">
        {/* <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h6 className="sub-title opacity-7 mb-15">Our Services</h6>
            <h3>
              Turn Information{' '}
              <span className="main-color">Into Actionable</span> Insights
            </h3>
          </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h6 className="sub-title opacity-7 mb-15">My Services</h6>
            <h3>
              Building <span className="main-color">Scalable Web</span>{" "}
              Applications
            </h3>
            <p className="mt-3 opacity-8">
              I specialize in Full-Stack Development with the MERN stack,
              WordPress customization, API integration, and creating responsive
              user interfaces that deliver seamless digital experiences.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        {data.map((item, index) => (
          <div key={index} className="col-md-6">
            <div className="item mb-40 wow fadeIn" data-wow-delay=".2s">
              <span className="icon-img-70 mb-30 opacity-7">
                <img src={item.icon} alt="" />
              </span>
              <h6 className="text-u ls1 mb-15">{item.title}</h6>
              <p>{item.description}</p>
              <div className="bord-color"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
